import type { Country } from "./constants/countries";

export interface Charity {
	id: number;
	name: string;
	category: string;
	thumbnail?: string;
	is_internal: boolean;
}

export interface FormData {
	recurring: boolean; // true for monthly, false for one-time
	allocationType: "default" | "specific";
	basicDonationAmountCents: number; // Amount in HKD cents
	specificAllocationsCents: Record<string, number>; // Amounts in HKD cents
	tipType: "percentage" | "dollar";
	tipSize: number; // Percentage or dollar amount for UI
	tipAmountCents: number; // Calculated tip amount in HKD cents
	firstName: string;
	lastName: string;
	email: string;
	country: Country;
	paymentMethod: "credit-card" | "bank-transfer";
	subscribeToUpdates: boolean;
	howDidYouHearAboutUs: string;
}

// Utility functions for cent/dollar conversion
export const dollarsToCents = (dollars: number): number =>
	Math.round(dollars * 100);
export const centsToDollars = (cents: number): number => cents / 100;
export const formatCentsAsDollars = (cents: number): string =>
	`$${(cents / 100).toFixed(2)}`;

export interface ReferralSource {
	value: string;
	label: string;
}
